import React from 'react';

import { CDN_URL, getCdnImageUrl } from '@utils/cloudflare';
import StarRating from '@components/common/StarRating';

import ImageLoaded from '@components/common/ImageLoaded/ImageLoaded';
import Button from '../Button';
import { isValidHttpUrl } from '../utils';

export type HotelCardProps = {
  imageUrl: string;
  name: string;
  location: string;
  rating: number;
  reviews: number;
  description: string;
  url: string;
};

export default function HotelCard({
  imageUrl,
  name,
  location,
  rating,
  reviews,
  description,
  url,
}: HotelCardProps) {
  const isUrl = isValidHttpUrl(imageUrl);
  const hotelImage = isUrl ? imageUrl : getCdnImageUrl(720, imageUrl, CDN_URL);
  return (
    <div className="flex flex-col gap-1 max-w-342 h-420 items-start min-w-0">
      <div className="flex flex-col gap-6 items-start w-full">
        <div className="h-196 relative d:h-236">
          <ImageLoaded url={hotelImage} classes="rounded-md" alt={name} />
          <div className="absolute bottom-3 right-1.5">
            <Button size="md" color="primary" type="link" href={url}>
              View
            </Button>
          </div>
        </div>
        <h1 className="text-xl text-left w-full line-clamp-1">{name}</h1>
      </div>
      <p className="text-sm">{location}</p>
      <div className="flex text-rp-primary-redesign text-sm">
        <StarRating rating={rating.toString()} size="4" isDesignSystemStar />| {reviews} Reviews
      </div>
      <p className="text-sm text-left line-clamp-5 d:line-clamp-4">{description}</p>
    </div>
  );
}
